import React from 'react';
import { Select as BaseSelect, SelectProps, Tooltip } from 'antd';
import { FormikErrors } from 'formik';
import { StyledSelect, Title } from './styles';
import { ISelect } from './types';

export type ISelectProps<T = any> = SelectProps<T> & {
    name: string;
    label?: string;
    error?: string;
    data: Array<ISelect>;
    setValue: (
        field: string,
        value: string,
        shouldValidate?: boolean | undefined,
    ) => Promise<FormikErrors<any>> | Promise<void>;
};

const { Option } = BaseSelect;
const Select: React.FC<ISelectProps> = ({
    children,
    name,
    label,
    error,
    data,
    setValue,
    ...rest
}) => {
    function handleChange(value: any) {
        setValue(name, value);
    }

    return (
        <>
            <Tooltip placement="topLeft" title={error ?? null}>
                <Title>{label}</Title>
                <StyledSelect
                    id={name}
                    error={error}
                    style={{ width: '100%' }}
                    {...rest}
                    onChange={(value) => handleChange(value)}
                >
                    {data.map((item) => {
                        return (
                            <Option value={item.value} key={item.value}>
                                {item.label}
                            </Option>
                        );
                    })}
                    {children}
                </StyledSelect>
            </Tooltip>
        </>
    );
};

export default Select;
